import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {RoomParty} from '../../../graphql/groups.datatypes';
import {gqlRoomParty} from '../getRoomParty.api';

interface DeleteRoomPartyInput {
    id: number
}

interface DeleteRoomPartyData {
    deleteRoomParty: RoomParty
}

export const DELETE_ROOM_PARTY_MUTATION = gql`
    mutation deleteRoomParty($id: Int!) {
        deleteRoomParty(id: $id) {
            ${gqlRoomParty}
        }
    }
`;

export const deleteRoomParty = () => useMutation<DeleteRoomPartyData, DeleteRoomPartyInput>(
    DELETE_ROOM_PARTY_MUTATION,
    {
        update: updateCacheByType('RoomParty'),
    }
);

export default deleteRoomParty;